import {field} from 'mc';
import {DateRangeField} from 'mc/lib/field';
import {Filter} from 'mc/lib/filter';
import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import * as StavZadosti from '../../api/StavZadosti';
import EnumField from '../../field/EnumField';
import SubjektField from '../../field/SubjektField';

export default class ZadostFilter extends PureComponent {

    static propTypes = {
        values: PropTypes.object.isRequired,
        onChange: PropTypes.func,
    };

    constructor(props) {
        super(props);

        this.fields = [
            {
                name: 'pouzeNevyrovnane',
                label: 'Žádosti',
                initialValue: true,
                component: this.renderPouzeNevyrovnane,
            },
            {
                name: 'vs',
                label: 'VS',
                component: field.String,
            },
            {
                name: 'drzitel',
                label: 'Držitel',
                component: this.renderDrzitel,
            },
            {
                name: 'cislo',
                label: 'Číslo žádosti',
                component: field.String,
            },
            {
                name: 'stav',
                label: 'Stav žádosti',
                initialValue: null,
                component: this.renderStav,
            },
            {
                name: 'buVratka',
                label: 'Číslo účtu pro vratku',
                component: field.String,
            },
            {
                name: 'datumPodani',
                label: 'Datum podání',
                component: DateRangeField,
            },
        ];
    }

    renderPouzeNevyrovnane = ({onChange, ...props}) => {
        return <field.Select {...props} onChange={onChange && (event => onChange(event.target.value === 'true'))}>
            <option value={true}>Nevyrovnané</option>
            <option value={false}>Všechny</option>
        </field.Select>
    };

    renderDrzitel = props => {
        return <SubjektField kodRole="POP_DRZITEL" {...props}/>;
    };

    renderStav = props => {
        return <EnumField items={StavZadosti.values}
                          itemRender={StavZadosti.getCaption}
                          {...props}/>;
    };

    render() {
        const {values, onChange} = this.props;
        return <Filter fields={this.fields}
                       values={values}
                       onChange={onChange}/>;
    }

}
